import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-input__box__inner" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ml-5 text-base font-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "checkbox-input flex w-full items-center cursor-pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('checked')))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["checkbox-input__box", { '--checked': _ctx.checked }])
    }, _hoisted_2, 2),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1)
  ]))
}